<article>
  <h1 class="tw-text-xl tw-font-medium tw-text-title-color" [class.tw-text-center]="isMobile">{{title}}</h1>
  <section class="tw-pt-[30px]">
    <ng-content></ng-content>
  </section>
</article>
